import campaignActionSharedGetters from '@/campaign-action-shared/store/getters'
import i18n from '@/phoenix/translations'
import { MIN_MD_SCREEN_WIDTH } from '@/constants'

const SIGNATURES_COUNT_DISPLAY_MINIMUM = 5

export default {
  ...campaignActionSharedGetters,

  showFixedSignButton: (state) => {
    return !state.signed && !state.petition.signatureFormHidden
  },

  showProgressBar: (state) => {
    return !state.petition.progressBarHidden && state.progress.currentSignaturesCount >= SIGNATURES_COUNT_DISPLAY_MINIMUM
  },

  showProgressBarOnForm: (state, getters) => {
    return getters.showProgressBar && state.windowWidth >= MIN_MD_SCREEN_WIDTH
  },

  showProgressBarAboveFixedSignButtom: (state, getters) => {
    return getters.showProgressBar && getters.showFixedSignButton && state.windowWidth < MIN_MD_SCREEN_WIDTH
  },

  showSidebar: (state, getters) => {
    return getters.showSidebarForScreenSize || state.signed
  },

  submitButtonText: (state) => {
    if (state.overriddenSubmitButtonText) {
      return state.overriddenSubmitButtonText
    }
    else if (state.petition.signersWriteToDecisionMaker) {
      return i18n.t('buttons.send_message')
    }
    else {
      return i18n.t('buttons.sign')
    }
  }
}
